<template>
  <div class="global-progress__container">
    <span
      :style="{ transform: 'scaleX(' + value + ')' }"
      aria-hidden="true"
      class="global-progress__progress"/>
    <span
      aria-hidden="true"
      class="global-progress__background"/>
    <progress
      :value="value"
      class="global-progress"
      v-text="progress"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'TheProgress',
    computed: {
      value() {
        const { questions, activeQuestion, stage } = this;

        return (
          (questions.indexOf(activeQuestion) * 2) + (stage === 'answer') + 1
        ) / (questions.length * 2);
      },
      progress() {
        return `${(this.value * 100).toFixed()}%`;
      },
      ...mapState(['questions', 'activeQuestion', 'stage']),
    },
  };
</script>

<style lang="scss">

  .global-progress__container {
    @include z-index(progress);
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 20px;
    opacity: 0;
    transition-duration: 150ms;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }

  .stage__answer,
  .stage__question {
    .global-progress__container {
        opacity: 1;
        transition-delay: $stage-transition-duration;
    }
  }

  .global-progress {
    opacity: 0;
  }

  .global-progress__progress,
  .global-progress__background {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8px;

    @include breakpoint(medium) {
      height: 15px;
    }
  }

  .global-progress__progress {
    background-color: $turquoise;
    z-index: 2;
    transform-origin: left;
    transition: transform $progress-transition-duration $progress-transition-timing-function;
  }

  .global-progress__background {
    background-color: rgb(212, 161, 103);
    z-index: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/TheProgress.vue